import Box from "@mui/material/Box";
import { Theme } from "../../data/style/Theme";

const MainCard = ({
  children,
  pd = "10px",
  height = "100%",
  start = "#f97316",
  middle = "#ea580c",
  end = "rgba(249,115,22,.04)",
}) => {
  return (
    <Box
      sx={{
        height: height,
        background: Theme.palette.surface,
        borderRadius: 4,
        border: `1px solid ${Theme.palette.border}`,
        overflow: "hidden",
        boxShadow: "0 4px 32px rgba(0,0,0,0.4)",
      }}
    >
      {/* Accent stripe */}
      <div
        style={{
          height: 2,
          background: `linear-gradient(90deg,${start},${middle},${end})`,
        }}
      />
      <Box sx={{ padding: pd }}>{children}</Box>
    </Box>
  );
};

export default MainCard;
